import styled from "styled-components"
import {Link} from "react-router-dom"

export const CvContainer=styled.div`
background-color: red;
display:flex;
flex-direction:column;
justify-content:center;
align-items:center;
background: #fff;
height:auto;
margin-bottom:30px;
background-color: #dedede;
height: 900px;  

@media screen and (max-width: 768px){
    height: 600px;
}
`

export const CvWrapper = styled.div`
display:grid;
justify-content: center;
align-items: center;
max-width: 1100px;
margin:auto 0;
height: auto;
width: 100%;
justify-content: center;
margin-right: auto;
margin-left: auto;
`

export const CvImage = styled.img`
width: 80%;
height:auto;
margin-right: auto;
margin-left: 2.5rem;
`

export const CvLinks = styled(Link)`
background: #047aed;
white-space:nowrap;
padding: 10px 25px;
text-decoration:none;
color: #fff;
font-size: 18px;
text-align:center;
outline:none;
margin-bottom:5px;
font-weight:bold;
border: none;
cursor:pointer;
max-width: 300px;
margin: 0 auto;
margin-top: 1.5rem;
border-radius: 10px;
box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.2);

&:hover{
    transform:scale(0.98);
}
`